import _styled from "styled-components";
import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import { MODAL_HEIGHT_CSS_VAR } from "../constants/cssVariables";
import { Body } from "./Body";
import { Footer } from "./Footer";
import { Header } from "./Header";
import * as styles from "../styles/Modal.styles";
var setModalHeight = function setModalHeight() {
  return document.documentElement.style.setProperty(MODAL_HEIGHT_CSS_VAR, "".concat(window.innerHeight, "px"));
};
var CLOSE_TIMEOUT_MS = 250;
export var MODAL_CONTENT_CLASS_NAMES = {
  base: 'ribbons-modal-content',
  afterOpen: 'ribbons-modal-content--afterOpen',
  beforeClose: 'ribbons-modal-content--beforeClose'
};
export var MODAL_OVERLAY_CLASS_NAMES = {
  base: 'ribbons-modal-overlay',
  afterOpen: 'ribbons-modal-overlay--afterOpen',
  beforeClose: 'ribbons-modal-overlay--beforeClose'
};
var ModalGlobalStyles = styles.ModalGlobalStyles({
  contentClassNames: MODAL_CONTENT_CLASS_NAMES,
  overlayClassNames: MODAL_OVERLAY_CLASS_NAMES,
  tranistionMS: CLOSE_TIMEOUT_MS
});
export var Modal = function Modal(_ref) {
  var _ref$appRootSelector = _ref.appRootSelector,
    appRootSelector = _ref$appRootSelector === void 0 ? '#NOTHSPageWrapper' : _ref$appRootSelector,
    children = _ref.children,
    contentLabel = _ref.contentLabel,
    isModalOpen = _ref.isModalOpen,
    onModalClose = _ref.onModalClose;
  ReactModal.setAppElement(appRootSelector);
  useEffect(function () {
    setModalHeight();
    window.addEventListener('resize', setModalHeight);
    return function () {
      return window.removeEventListener('resize', setModalHeight);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalGlobalStyles, null), /*#__PURE__*/React.createElement(ReactModal, {
    className: MODAL_CONTENT_CLASS_NAMES,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    contentLabel: contentLabel,
    isOpen: isModalOpen,
    onAfterOpen: setModalHeight,
    onRequestClose: onModalClose,
    overlayClassName: MODAL_OVERLAY_CLASS_NAMES
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.modalWrapper
  }, children({
    Header,
    Body,
    Footer
  }))));
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "Modal___StyledDiv",
  componentId: "sc-1mnjvr4-0"
})(["", ""], function (p) {
  return p.$_css;
});